import script from "./AppSideNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSideNotification.vue?vue&type=script&setup=true&lang=js"

import "./AppSideNotification.vue?vue&type=style&index=0&id=45188a34&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45188a34"]])

export default __exports__